export default __webpack_public_path__ + "static/media/loginbg3.daa9b279.jpg";